// extracted by mini-css-extract-plugin
export var numpadContainer = "_qr-1";
export var phoneButton = "_qr-0";